import {Component, OnDestroy, OnInit} from '@angular/core';
import {Subscription} from 'rxjs';


@Component({
  selector: 'app-loading-screen',
  templateUrl: './loading-screen.component.html',
  styleUrls: ['./loading-screen.component.css']
})
export class LoadingScreenComponent implements OnInit, OnDestroy {
  isLoadingSubscription: Subscription;

  constructor() {

  }

  ngOnInit(): void {
  }

  ngOnDestroy() {
    this.isLoadingSubscription?.unsubscribe();
  }
}
